// extracted by mini-css-extract-plugin
module.exports = {"customError":"custom-error_component_customError__RWfBL"};